import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { environment } from 'src/environments/environment';
import { SetCanonical, SetTags, SetTitle } from '../store';

export const SearchMetaGuard: CanActivateFn = route => {
  const store = inject(Store);
  const lang = inject(LanguageService);
  const dict = new FromDictionaryPipe(lang);

  store.dispatch(
    SetTitle({
      title: `${dict.transform('zoek-meta-titel')} ${dict.transform('meta-titel-suffix') ? '- ' + dict.transform('meta-titel-suffix') : ''}`,
    })
  );
  store.dispatch(SetCanonical({ url: `${environment.canonicalDomain}/zoeken` }));
  store.dispatch(
    SetTags({
      properties: {
        'description': StringUtility.Truncate(StringUtility.StripHTML(dict.transform('zoek-meta-tekst')), 157, '...'),
        'og:title': `${dict.transform('zoek-meta-titel')} ${dict.transform('meta-titel-suffix') ? '- ' + dict.transform('meta-titel-suffix') : ''}`,
        'og:description': StringUtility.Truncate(StringUtility.StripHTML(dict.transform('zoek-meta-tekst')), 157, '...'),
      },
    })
  );

  return true;
};
